var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInicio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-inicio"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inicio",
    clipPath: "url(#clip-inicio)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-home",
    "data-name": "Icon feather-home",
    transform: "translate(5.215 2.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_797",
    "data-name": "Trazado 797",
    d: "M4.5,34.333,44.785,3,85.07,34.333V83.57a8.952,8.952,0,0,1-8.952,8.952H13.452A8.952,8.952,0,0,1,4.5,83.57Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6c637b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_798",
    "data-name": "Trazado 798",
    d: "M13.5,62.761V18H40.357V62.761",
    transform: "translate(17.857 29.761)",
    fill: "none",
    stroke: "#6c637b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInicio);
export default __webpack_public_path__ + "static/media/inicio.e2b85e1461c8f291933178ed8c31a82c.svg";
export { ForwardRef as ReactComponent };